import OHolidaySettingList from './index.vue';

OHolidaySettingList.install = app => {
  app.component(OHolidaySettingList.name, OHolidaySettingList);
};

export default OHolidaySettingList;
